module.exports = __webpack_public_path__ + "static/media/gts12.8a681456.png";